import React from 'react';
import TimeUtils from 'app/common/util/TimeUtils';
import { InputFormat, InputFormatWrapperProps } from 'app/common/input/InputFormat';
import Utils from 'app/common/util/Utils';

export interface InputTimeProps extends InputFormatWrapperProps<Date> {
    referenceDay?: Date;
}

export default class InputTime extends React.PureComponent<InputTimeProps> {
    parse = (value: string) => {
        return TimeUtils.parseHHMM(value, this.props.referenceDay);
    };

    matches = (value: string, complete: boolean) => {
        return Utils.isExists(TimeUtils.matchHHMM(value, complete));
    };

    render() {
        const { referenceDay, ...otherProps } = this.props;
        return (
            <InputFormat
                {...otherProps}
                format={TimeUtils.formatHHMM}
                parse={this.parse}
                matches={this.matches}
                defaultWidth="4em"
            />
        );
    }
}
